function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.01,
  fill: "#fff",
  d: "M0 .316h20v20H0z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.833 2.816H12.35A2.509 2.509 0 0010 1.149c-1.083 0-2 .7-2.35 1.667H4.167c-.917 0-1.667.75-1.667 1.667v11.666c0 .917.75 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667V4.482c0-.916-.75-1.666-1.667-1.666zm-5.833 0c.458 0 .833.375.833.833a.836.836 0 01-.833.833.836.836 0 01-.833-.833c0-.458.375-.833.833-.833zm-5 8.333l3.333 3.334L15 7.816l-1.175-1.183-5.492 5.491-2.158-2.15L5 11.15z",
  fill: "#fff"
});

var SvgLessonsCompleted = function SvgLessonsCompleted(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml,%3Csvg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect opacity='0.01' y='0.315918' width='20' height='20' fill='white'/%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.8333 2.81584H12.35C12 1.84917 11.0833 1.14917 10 1.14917C8.91667 1.14917 8 1.84917 7.65 2.81584H4.16667C3.25 2.81584 2.5 3.56584 2.5 4.4825V16.1492C2.5 17.0658 3.25 17.8158 4.16667 17.8158H15.8333C16.75 17.8158 17.5 17.0658 17.5 16.1492V4.4825C17.5 3.56584 16.75 2.81584 15.8333 2.81584ZM10 2.81584C10.4583 2.81584 10.8333 3.19084 10.8333 3.64917C10.8333 4.1075 10.4583 4.4825 10 4.4825C9.54167 4.4825 9.16667 4.1075 9.16667 3.64917C9.16667 3.19084 9.54167 2.81584 10 2.81584ZM5 11.1492L8.33333 14.4825L15 7.81584L13.825 6.6325L8.33333 12.1242L6.175 9.97417L5 11.1492Z' fill='white'/%3E %3C/svg%3E";
export { SvgLessonsCompleted as ReactComponent };